import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AuthState } from './auth.reducer';

export const selectAuthState = createFeatureSelector<AuthState>('auth');

export const selectAccessToken = createSelector(selectAuthState, (state) => state.accessToken);
export const selectAuthStatus = createSelector(selectAuthState, (state) => state.status);
export const selectAuthError = createSelector(selectAuthState, (state) => state.error);
export const selectAuthInitialized = createSelector(selectAuthState, (state) => state.initialized);
export const selectIsAuthenticated = createSelector(
  selectAuthState,
  (state) => !!state.accessToken && state.status === 'authenticated',
);
